import 'react-toastify/dist/ReactToastify.css';

import React, { Component } from "react";
import PropTypes from 'prop-types';
import classNames from 'classnames';

import BaseLayout from "../../containers/BaseLayout";
import NavBar from "../../containers/NavBar";
import RestrictedNotification from "../../containers/RestrictedNotification";

import RestrictedNavbar from "../../containers/RestrictedNavbar";
import ProjectFinderNavBar from "../../containers/ProjectFinderNavBar";

import QuickNav from "../../containers/QuickNav";
import Header from "../../containers/Header";
import Notification from "../../containers/Notification";
import ReferralModal from "../../../referrals/containers/Modal";
import isWebview from "is-ua-webview";
import { isRestrictedAccess } from '../../../../utils/cookies';
import { ToastContainer } from 'react-toastify';

class MainLayout extends Component {
  get gridClassName() {
    return classNames(
      'grid',
      this.props.gridClassName
    )
  }

  renderNavBar = () => {
    const currentUrl = window.location.pathname;
    if (currentUrl.includes("project-finder")) {
      return (
        <ProjectFinderNavBar />
      )
    } else if (isRestrictedAccess()) {
      return (
        <React.Fragment>
          <RestrictedNotification/>
          <RestrictedNavbar />
        </React.Fragment>
      )
    } else {
      return (
        <React.Fragment>
          <Notification />
          <NavBar />
        </React.Fragment>
      );
    }
  }

  render() {
    return (
      <BaseLayout className={this.props.containerClassName}>
        {this.renderNavBar()}
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        <ReferralModal />
        <div className={this.gridClassName}>
          <Header
            header={this.props.header}
            backButtonAction={this.props.backButtonAction}
            backButtonLabel={this.props.backButtonLabel}
          />
          {this.props.children}
        </div>
        {
          this.props.showQuickNav ? <QuickNav /> : <div></div>
        }
      </BaseLayout>
    )
  }
}

MainLayout.propTypes = {
  backButtonAction: PropTypes.func,
}

MainLayout.defaultProps = {
  backButtonAction: null,
  showQuickNav: isWebview,
}

export default MainLayout;



// WEBPACK FOOTER //
// ./src/features/shared/components/layouts/MainLayout.js